import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Box,
  Grid,
  GridItem,
  Center,
  Image as ChakraImage,
  Icon,
  Input,
  Button,
  useClipboard,
} from "@chakra-ui/react";
import logo from "@/assets/images/logo3.png";
import { useRef, useState } from "react";
import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  bannerSrc: string;
  linkSrc: string;
  title?: string;
};

const InviteModal = (props: Props) => {
  const { isOpen, onClose, bannerSrc, linkSrc, title } = props;
  const { onCopy, value, setValue, hasCopied } = useClipboard(linkSrc);
  const imageBoxRef = useRef<HTMLDivElement>(null);

  const saveAsImage = () => {
    const node = imageBoxRef.current!;

    html2canvas(node,{
      useCORS: true, // 允许跨域
      // scale: 2 // 提高scale来改善图片质量
    }).then((canvas) => {
      // 创建一个图片元素
      const img = new Image();
      img.src = canvas.toDataURL('image/png');
      img.style.display = 'none';
      document.body.appendChild(img);
  
      // 触发下载
      const downloadLink = document.createElement('a');
      downloadLink.href = img.src;
      downloadLink.download = 'chakra-ui-component.png';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(img);
      document.body.removeChild(downloadLink);
    });
  }

  // const [linkSrcText, setLinkSrcText] = useState<string>(linkSrc);
  // const handleLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setLinkSrcText(e.target.value);
  // }
  // const copyLink = useCopyText({
  //   text:"",  //`${getSiteURL()}/signup_user_complete/?invitecode=`+data.randcode,
  //   successCopyTimeout: 1000,
  // })
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        w="359px"
        backdropFilter="blur(10px)"
        background="rgba(87, 87, 87, 0.9)"
      >
        <ModalHeader pb="10px" color={"#FFFFFF"} fontSize="18px" fontWeight={"normal"}>
          {title}
        </ModalHeader>
        <ModalCloseButton color={"#fff"} />
        <ModalBody>
          <Box ref={imageBoxRef} h="553px" position={"relative"}>
            < ChakraImage width={"359px"} h="553px" src={bannerSrc} />
            <Box
              position={"absolute"}
              p="8px 10px"
              left="0"
              bottom={"0"}
              w="100%"
              h="110px"
              background="linear-gradient(180deg, rgba(142, 148, 169, 0.4) 0%, #27314D 101%)"
            >
              <Flex h="100%" alignItems={"center"}>
                <Box flex={1}>
                  < ChakraImage src={logo} />
                  <Box mt={"6px"} mb="9px" fontSize={"12px"} color="#FFFFFF">
                    建筑、装饰设计师的专属智能助手ALDGPT，一键将创意变为现实，让设计更简单、更出彩！
                  </Box>
                  <Box fontSize={"10px"} color="#E6E6E6">
                    By ALPGPT AI创作
                  </Box>
                </Box>
                <Box ml="13px" p="5px" bgColor={"#fff"}>
                  <QRCode size={65} value={value} />
                </Box>
              </Flex>
            </Box>
          </Box>
          <Flex mt="20px" alignItems={"center"}>
            <Input
            border={"none"}
              bg="rgba(0, 0, 0, 0.3)"
              variant={"outline"}
              borderRadius="2px"
              value={value}
              flex={1}
              fontSize="14px"
              color={"#8E94A9"}
              onChange={(e) => {setValue(e.target.value)}}
            />
            <Button
              w="64px"
              fontSize={"14px"}
              fontWeight="normal"
              color={"#DCE0EB"}
              colorScheme="whiteAlpha"
              ml={"26px"}
              mr="28px"
              bg="none"
              _hover={{
                bg:"none"
              }}
              onClick={onCopy}
            >
              {hasCopied ? '已复制' : '复制链接'}
              {/* {!copyLink.copiedRecently && "复制链接"} */}
              {/* {copyLink.copiedRecently && "已复制"} */}
            </Button>
          </Flex>
          <Button
            w={"100%"}
            h="54px"
            mt="20px"
            mb="20px"
            borderRadius={"2px"}
            fontSize="18px"
            color={"#FFFFFF"}
            background={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"}
            _hover={{
              background: "linear-gradient(90deg, #27314D 0%, #8E94A9 100%)",
            }}
            onClick={saveAsImage}
          >
            保存图片
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default InviteModal;
